export function replaceSearchNotification(notifications, newNotification) {
  const notificationIndex = notifications.findIndex(
    notification => notification.id === newNotification.id
  );

  const newNotifications = [...notifications];
  newNotifications[notificationIndex] = newNotification;
  return newNotifications;
}

export function deleteSearchNotification(notifications, willDeleteNotification) {
  return notifications.filter(notification => notification.id !== willDeleteNotification.id);
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/SearchNotifications/utils.js